<template>
  <div>
    <el-card class="upload-pop">
      <div slot="header"
           class="clearfix">
        <span>上传文件</span>
      </div>
      <el-form 
        label-position="right"
        :model="uploadData"
        status-icon
        label-width="100px"
        class="demo-ruleForm"
        :rules="rules"
        ref="uploadData"
      >
        <el-form-item label="文件选择:">
          <el-upload 
            :multiple="true"
            ref="upload"
            action=""
            :on-change="handleFileChange"
            :auto-upload="false"
            :on-remove="handleRemove"
            :http-request="handleUpload"
            :file-list="uploadFilesList"
          >
            <el-button class="file-btn">文件选择</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input type="textarea" :rows="3" v-model="remark"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="mini"
                  @click="startUpload()">上传</el-button>
      <el-button size="mini" @click="cancleUpload()">取消</el-button>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
import { mapMutations } from 'vuex'
export default {
  name: 'personUpload',
  props: {
    modalInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      uploadData: {
        // 上传数据
        area: '',
        createUser: JSON.parse(localStorage.user).account,
        device: null,
        types: null,
        describe: null,
        file: null,
        fileCode: ''
      },
      rules: {
        area: [
          {
            required: true,
            message: '请选择区域',
            trigger: 'change'
          }
        ],
        device: [
          {
            required: true,
            message: '请选择设备',
            trigger: 'change'
          }
        ],
        types: [
          {
            required: true,
            type: 'number',
            message: '请选择分类',
            trigger: 'change'
          }
        ],
        describe: [
          {
            required: true,
            message: '请填写描述',
            trigger: 'blur'
          }
        ]
      }, // 校验规则
      areaList: [], // 设备列表
      deviceList: [
        {
          value: '1',
          label: '位置1'
        },
        {
          value: '2',
          label: '位置2'
        }
      ], // 区域列表
      typeList: null, // 类别列表
      file: null, // 文件
      fileList: [], // 
      remark: '',
      params: {},
      uploadFilesList: [],
      uploadFileList: [],
      chunkSize: 102400
    }
  },
  created() {
      console.log(this.modalInfo)
  },
  methods: {
    ...mapMutations(['showModal', 'closeModal']),
    // 移除文件
    handleRemove(file, fileList) {
      console.log('移除文件', fileList)
    },
    // 取消&关闭上传
    cancleUpload() {
      this.closeModal('personUpload')
      this.uploadData = {
        area: null,
        createUser: JSON.parse(localStorage.user).account,
        device: null,
        types: null,
        describe: null
      }
    },
    handleUpload() {
      this.uploadFilesList.forEach(n => {
        let params = new FormData()
        params.append('userID', JSON.parse(localStorage.user).userId)
        params.append('modifier', this.modalInfo.fileCreater ? this.modalInfo.fileCreater : JSON.parse(localStorage.user).account)
        params.append('creator', this.modalInfo.fileCreater ? this.modalInfo.fileCreater : JSON.parse(localStorage.user).account)
        params.append('ParentID', this.modalInfo.id === 1 ? '0' : String(this.modalInfo.id))
        params.append('remark', this.remark)
        params.append('formfile', n.raw)
        ApiService.person_doc.addPersonDoc(params).then(res => {
          if (res.code === 0) {
            this.$store.commit('reloadFile', Math.random())
            this.closeModal('personUpload')
            this.passShow = true
            this.uploadData = {
              area: null,
              createUser: JSON.parse(localStorage.user).account,
              device: null,
              types: null,
              describe: null
            }
            this.$message({
              message: '上传成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      })
    },
    startUpload() {
      // this.$refs.upload.submit()
      this.handleUpload()
    },
    // 控制选择文件按钮
    handleFileChange(file, fileList) {
      console.log(file)
      console.log(fileList)
      this.uploadFile = file
      this.uploadFilesList = fileList
    },
    handleChange() {
      console.log(this.uploadData.fileCode)
    }
  }
}
</script>
<style lang="scss">
@import '../../common/css/color.scss';
.upload-pop {
  width: 580px;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  .el-card__body {
    padding: 30px 40px;

    .el-form {
      .el-select {
        display: block;

        .el-input__inner {
          height: 32px;
          line-height: 32px;
          border-radius: 2px;
        }
      }

      .el-textarea__inner {
        resize: none;
        height: 50px;
        border-radius: 2px;
      }

      .file-btn {
        display: block;
        width: 80px;
        height: 32px;
        line-height: 32px;
        padding: 0;
        color: #999;
        font-size: 14px;
      }

      .el-upload {
        display: block;
      }
      .el-upload-list {
        max-height: 200px;
        overflow: auto;
        margin-top: 10px;
        border: 1px solid #eee;
      }
      .el-upload-list__item:first-child {
        margin-top: 0px;
      }

      .el-upload-list__item-name {
        display: flex;
      }

      .el-upload__input {
        display: none;
      }

      .el-form-item {
        margin-bottom: 16px;

        .el-form-item__label {
          line-height: 32px;
        }
        .el-form-item__content {
          width: 360px;
          .el-cascader {
            display: block;
          }
        }
      }
    }
  }
}
.el-cascader-panel {
  .el-scrollbar__wrap {
    overflow: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/personDriveUpload.vue